import CardHeader from "components/CardHeader";
import Date from "components/Date";
import React from "react";
import { connect } from "react-redux";
import { RootState } from "store/store";
import { Card, CardBody } from "reactstrap";
import { EmailState } from 'store/reducers/Emails';
import WaitingDots from "../../components/WaitingDots";
import { Link } from "react-router-dom";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

interface Props {
    emailState: EmailState;
}

interface OwnProps { limit?: number; }

const UnreadEmailCard: React.FC<Props & OwnProps> = ({ emailState, limit = 10 }) => {
    const { t } = useOfficeTranslation();

    const unread = emailState.getEmails()
        .filter(email => (email.reader === null || email.reader.length === 0) && email.direction === "in")
        .sort((a, b) => (a.date < b.date) ? 1 : (a.date > b.date) ? -1 : 0);

    return (
        <Card className="h-100 mb-0 dashboard-widget-card">
            <CardBody>
                <CardHeader title={t("email.unreadEmailCard.unreadConversations")} icon="mdi-email-outline" count={unread.length} />
                {emailState.isFetched() && unread.length === 0
                    ?
                    <p className="text-muted mt-3 mb-0">{t("email.unreadEmailCard.noUnreadConversations")}</p>
                    :
                    <div className="dashboard-widget-scroll">{unread.slice(0, limit).map(email =>
                        <Link to={`/conversation/${email.id}`} className="d-block text-body border-bottom py-3" key={email.id}>
                            <div className="d-flex justify-content-between gap-3">
                                <strong className="text-truncate">{email.subject || t("common.noSubject")}</strong>
                                <small className="text-muted flex-shrink-0"><Date date={email.GetDate()} /></small>
                            </div>
                            <small className="text-muted text-truncate d-block">
                                {t("common.from")} {email.sender_name || email.sender}
                            </small>
                        </Link>
                    )}</div>
                }
                {!emailState.isFetched() &&
                    <div className="text-center pt-3">
                        <WaitingDots />
                    </div>
                }
            </CardBody>
        </Card>
    );
}

const mapStateToProps = (state: RootState) => {
    return {
        emailState: state.Emails,
    };
};

export default connect(mapStateToProps)(UnreadEmailCard);
